import styled from 'styled-components';
import { getVariantColor } from 'ui/theme/helpers';
import { VariantTypes } from 'ui/uiTypes';

interface LinksProps {
  desktop?: boolean;
  variant?: VariantTypes;
}

interface OptionProps {
  variant?: VariantTypes;
}

export const Links = styled.div<LinksProps>`
  font-size: 1em;
  display: flex;
  justify-content: flex-end;
  > div {
    margin-left: 1rem;
  }
  #seperator {
    margin-left: 1rem;
  }

  a {
    text-decoration: none;
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
  }
  > span {
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
    font-family: ${({ theme }) => theme.fonts.secondary};
    ${getVariantColor()}
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    span {
      display: none;
    }
  }

  ${({ desktop }) =>
    desktop
      ? `
        @media (max-width: 960px) {
            display: none;
        }
    `
      : `
        padding: 3rem;
        display: flex;
        flex-direction: column;

        a {
            margin-bottom: 1rem;

            &:last-child {
                margin-bottom: unset;
            }
        }
    `}
`;

export const StyledButton = styled.button`
  cursor: pointer;
  border: none;
  position: relative;
  top: 0.3rem;
  background: none;
  text-align: left;

  img {
    margin: 0;
  }
`;

export const Option = styled.span<OptionProps>`
  font-weight: ${({ theme }) => theme.fonts.weight.bold};
  font-family: ${({ theme }) => theme.fonts.secondary};
  ${getVariantColor()}
`;

export const MenuControl = styled.div`
  display: none;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
    position: absolute;
    right: 10px;
  }
`;

export const SideNavBarHomePage = styled.div`
  background-color: ${({ theme }) => theme.colors.grey[800]};
`;

export const CloseIconContainer = styled.div`
  padding: 1rem;
`;

export const SideNavHomePageContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  a {
    margin-bottom: 2rem;
  }
`;
